import { Repository} from "./Repository";
import { AxiosInstance} from "axios";
import { PointInterface } from "../models/interfaces/PointInterface";
import { Point } from "../models/Point";
import {QueryParametersInterface} from "./interfaces/QueryParametersInterface";

export class PointRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    query<T extends Point[]>(query: QueryParametersInterface = {}, groups: Array<string> = []): Promise<T> {
        let params = new URLSearchParams();
        groups.forEach(item => {
            params.append('groupIdsFilter', item);
        })
        
        return this.client.post(`/points/rating/query`, query, {
            params: params
        })
            .then(({data}) => {
                return data.map((item: PointInterface) => new Point(item));
            });
    }
}